export default "https://cdn-static.gokick.com/assets/0205635f2685a00e1fdcb9112c4ac213a84703ca/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";